import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { dataFormats } from '../../utils/data';
import { protectedResources } from '../auth/auth.config';
import { CreateProjectDto, ProjectDto } from '../models/project.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  public project?: Partial<ProjectDto>;

  apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  constructor(private http: HttpClient) {}

  getAllProjects(): Observable<ProjectDto[]> {
    return this.http.get<ProjectDto[]>(`${this.apiEndpoint}/projects`);
  }

  getProjectById(projectId: string): Observable<ProjectDto> {
    return this.http.get<ProjectDto>(
      `${this.apiEndpoint}/projects/${projectId}`,
    );
  }

  createProject(project: CreateProjectDto): Observable<ProjectDto> {
    return this.http.post<ProjectDto>(`${this.apiEndpoint}/projects`, project);
  }

  updateProject(
    projectId: string,
    project: CreateProjectDto,
  ): Observable<ProjectDto> {
    return this.http.put<ProjectDto>(
      `${this.apiEndpoint}/projects/${projectId}`,
      project,
    );
  }

  deleteProject(projectId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiEndpoint}/projects/${projectId}`);
  }

  getOutcomeFormats() {
    return dataFormats.mainFormats
      .filter((format) => {
        switch (format.name) {
          case 'orthophoto':
            return this.project?.dataNeed?.orthophoto;
          case 'dtm':
            return this.project?.dataNeed?.dtm;
          case 'dsm':
            return this.project?.dataNeed?.dsm;
          default:
            return false;
        }
      })
      .map((format) => format.label)
      .join(', ');
  }

  getOutcomeType() {
    return dataFormats.subFormatBoxes.boxes
      .filter((format) => {
        switch (format.name) {
          case 'pointCloud':
            return this.project?.dataNeed?.pointCloud;
          case 'mesh':
            return this.project?.dataNeed?.mesh;
          case 'raster':
            return this.project?.dataNeed?.raster;
          default:
            return false;
        }
      })
      .map((format) => format.label)
      .join(', ');
  }
}
